class MobileNavToggle extends HTMLElement {
	constructor() {
		super()
		this.menuDrawer = document.querySelector('.f-drawer-mobile-nav')
		this.addEventListener('click', this.openNav.bind(this))

		if (this.menuDrawer) {
			this.menuDrawer.addEventListener('close', () => {
				this.setAttribute('aria-expanded', 'false')
			})
		}
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.openNav.bind(this))
	}

	openNav() {
		if (this.menuDrawer) {
			this.menuDrawer.openDrawer()
			this.setAttribute('aria-expanded', 'true')
		}
	}
}
customElements.define('mobile-nav-toggle', MobileNavToggle)

// Mobile nav collapsible functionality
function initMobileNavCollapsible() {
	// Find all mobile nav links with the collapsible trigger data attribute
	const collapsibleLinks = document.querySelectorAll('#Mobile-Nav [data-collapsible-trigger]')
	
	collapsibleLinks.forEach(link => {
		// Skip if already initialized
		if (link.dataset.collapsibleInitialized) return
		
		// Make the span clickable
		link.style.cursor = 'pointer'
		link.setAttribute('role', 'button')
		link.setAttribute('tabindex', '0')
		
		// Add click handler
		link.addEventListener('click', (e) => {
			e.preventDefault()
			toggleCollapsible(link)
		})
		
		// Add keyboard support (Enter and Space)
		link.addEventListener('keydown', (e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault()
				toggleCollapsible(link)
			}
		})
		
		// Mark as initialized
		link.dataset.collapsibleInitialized = 'true'
	})
}

function toggleCollapsible(link) {
	// Find the collapsible-tab element within the same list item
	const listItem = link.closest('li')
	const collapsibleTab = listItem.querySelector('collapsible-tab')
	
	if (collapsibleTab) {
		// Find the data-trigger element and simulate a click
		const trigger = collapsibleTab.querySelector('[data-trigger]')
		if (trigger) {
			trigger.click()
		}
	}
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initMobileNavCollapsible)

// Also initialize when the mobile nav is opened (for AJAX-loaded content)
document.addEventListener('quick-view:loaded', initMobileNavCollapsible)
